import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import bg from '@/assets/dialogs/dialog-mission-completed/mission-complite.svg';
import coinMd from '@/assets/icons/coin-icn-sm.svg';
import keyMd from '@/assets/icons/key-icn-md.svg';
import { Button } from '@/components/Button';
import { Dialog } from '@/components/Dialogs';
import { Missions } from '@/types/models/mission';
import { formatNumber } from '@/utils/format';

type DialogMissionCompletedProps = {
  isOpen: boolean;
  onClose: () => void;
  onAction: () => void;
  mission: Missions | null;
};

export const DialogMissionCompleted = observer<DialogMissionCompletedProps>(
  ({ mission, isOpen, onAction, onClose }) => {
    const { t } = useTranslation();

    if (!mission) return null;

    return (
      <Dialog.Base isOpen={isOpen} onClose={onClose} canClose>
        <Dialog.Header>
          <Dialog.Image src={bg} />
          <Dialog.Title style={{ marginTop: '50px' }}>
            {t(mission.name)}
          </Dialog.Title>
        </Dialog.Header>
        <Dialog.Text>{t('dialogs.missionCompleted.title')}</Dialog.Text>
        <Dialog.Text>{t('dialogs.missionCompleted.title2')}</Dialog.Text>
        <Dialog.Main className="in-row-center in-text-h2 in-gap-10">
          {!!mission.keys && (
            <div className="in-row-center in-gap-10">
              <img src={keyMd} width={40} />
              <span>{`+${mission.keys}`}</span>
            </div>
          )}
          {!!mission.coins && (
            <div className="in-row-center in-gap-10">
              <img src={coinMd} width={40} />
              <span>{`+${formatNumber(mission.coins)}`}</span>
            </div>
          )}
        </Dialog.Main>
        <Dialog.Footer>
          <Button onClick={onAction}>
            {t('dialogs.missionCompleted.action')}
          </Button>
        </Dialog.Footer>
      </Dialog.Base>
    );
  },
);
